// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2PPDE","location":"Header_location__2WPfY"};